import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class AppValidators {
    /**
     * Proper email validation regex
     */
    static email(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) {
                return null;
            }

            const emailRegex = /^[a-z0-9._%+-]+@(?:[a-z0-9-]+\.)+[a-z]{2,4}$/i;
            const valid = emailRegex.test(control.value);
            return valid ? null : { invalidEmail: true };
        };
    }

    /**
     * Rejects whitespace-only text, which Validators.required accepts.
     * Reports the `required` error key so existing "is required" messages
     * cover it without a second error line per field.
     */
    static notBlank(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (typeof control.value !== 'string') {
                return null;
            }

            return control.value.trim().length ? null : { required: true };
        };
    }
}
